import React from 'react';
import {Link} from 'react-router';

export const NetworkBenefits = () => {
  return (
    <div className="membership-info-background-image">
      <div className="cover-transparent">
        <div className="container">
          {/*membership upgrade ad*/}
          <div className="row">
            <div className="col-xs-12 col-md-6">
              <ul className="membership-benefits">
                <li className="row">
                  <span className="col-xs-3 col-sm-2 icon-benefits"><img src="/images/icon_membership-benefits-e-learningvideo.png" alt=""/></span>
                  <span className="col-xs-9 col-sm-10 label-benefits">Essential e-learning videos by award-winning coaches</span>
                </li>
                <li className="row">
                  <span className="col-xs-3 col-sm-2 icon-benefits"><img src="/images/icon_membership-benefits-video.png" alt=""/></span>
                  <span className="col-xs-9 col-sm-10 label-benefits">60+ modules to help advance your career</span>
                </li>
                <li className="row">
                  <span className="col-xs-3 col-sm-2 icon-benefits"><img src="/images/icon_membership-benefits-CPD.png" alt=""/></span>
                  <span className="col-xs-9 col-sm-10 label-benefits">Every course CPD-accredited and verified</span>
                </li>
                <li className="row">
                  <span className="col-xs-3 col-sm-2 icon-benefits"><img src="/images/icon_membership-benefits-CPDpoints.png" alt=""/></span>
                  <span className="col-xs-9 col-sm-10 label-benefits">Earn CPD points while you watch</span>
                </li>
                <li className="row">
                  <span className="col-xs-3 col-sm-2 icon-benefits"><img src="/images/icon_membership-benefits-24-7.png" alt=""/></span>
                  <span className="col-xs-9 col-sm-10 label-benefits">Learn when it suits you - 24/7 on-demand access</span>
                </li>
              </ul>
            </div>
            <div className="col-xs-12 col-md-6">
              <h5 className="h5">Every successful business person knows that professional development is a lifelong process.</h5>
              <h6 className="h6 ">Continued learning is essential for a prosperous career.</h6>
              <p className="p-tag">Created by our award-winning coaches, on-demand training offers a convenient, flexible and effective approach to professional learning and development. Whether you’re looking to improve job application success or enhance your performance in the boardroom, we have the knowledge to help you.</p>
              <p className="p-tag">On-Demand Training is included in Premium, Gold and Platinum membership packages. You’ll be awarded CPD points for each module you complete, a fantastic addition to your CV and a demonstration of your commitment to continued development.</p>
              <p className="p-tag">Find out how On-Demand Training has already helped our members to enhance their careers.</p>
              <Link className="btn btn-primary" to={`/testimonials`}>
                <span className="label">View testimonials</span>
                <span className="icon"><i className="fa fa-angle-right animated-right"/></span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};



// WEBPACK FOOTER //
// src/client/components/site/features/training/courses/pages/elements/NetworkBenefits.js